import { render } from "./file-attachment.vue?vue&type=template&id=d0fb33aa&ts=true"
import script from "./file-attachment.vue?vue&type=script&lang=ts"
export * from "./file-attachment.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__